function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * MicroEvent - to make any js object an event emitter
 *
 * - pure javascript - server compatible, browser compatible
 * - dont rely on the browser doms
 * - super simple - you get it immediatly, no mistery, no magic involved
 *
 * @author Jerome Etienne (https://github.com/jeromeetienne)
 */
/**
 * Execute callback for each event in space separated list of event names
 *
 */
function forEvents(events, callback) {
  events.split(/\s+/).forEach(function (event) {
    callback(event);
  });
}
var MicroEvent = /*#__PURE__*/function () {
  function MicroEvent() {
    _classCallCheck(this, MicroEvent);
    this._events = {};
  }
  _createClass(MicroEvent, [{
    key: "on",
    value: function on(events, fct) {
      var _this = this;
      forEvents(events, function (event) {
        var event_array = _this._events[event] || [];
        event_array.push(fct);
        _this._events[event] = event_array;
      });
    }
  }, {
    key: "off",
    value: function off(events, fct) {
      var _this2 = this;
      var n = arguments.length;
      if (n === 0) {
        this._events = {};
        return;
      }
      forEvents(events, function (event) {
        if (n === 1) {
          delete _this2._events[event];
          return;
        }
        var event_array = _this2._events[event];
        if (event_array === undefined) return;
        event_array.splice(event_array.indexOf(fct), 1);
        _this2._events[event] = event_array;
      });
    }
  }, {
    key: "trigger",
    value: function trigger(events) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var self = this;
      forEvents(events, function (event) {
        var event_array = self._events[event];
        if (event_array === undefined) return;
        event_array.forEach(function (fct) {
          fct.apply(self, args);
        });
      });
    }
  }]);
  return MicroEvent;
}();
export { MicroEvent as default };
;